import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import Layout from '../components/Layout'
import { ClientForm } from '../components/Forms'
import { Btn, Msg, inputCls } from '../components/ui'
import { clientLabel, inviteClient, type Client } from '../lib/db'

export default function Clients() {
  const [params, setParams] = useSearchParams()
  const [clients, setClients] = useState<Client[]>([])
  const [counts, setCounts] = useState<Record<string, number>>({})
  const [q, setQ] = useState('')
  const [form, setForm] = useState<Partial<Client> | null>(params.get('new') ? {} : null)
  const [msg, setMsg] = useState('')
  const [loading, setLoading] = useState(true)

  async function load() {
    const [{ data }, { data: p }] = await Promise.all([supabase.from('clients').select('*').order('company').order('full_name'), supabase.from('projects').select('client_id')])
    setClients((data as any) || [])
    const c: Record<string, number> = {}; (p || []).forEach((x: any) => { c[x.client_id] = (c[x.client_id] || 0) + 1 }); setCounts(c)
    setLoading(false)
  }
  useEffect(() => { load() }, [])

  async function invite(c: Client) {
    setMsg('')
    try { await inviteClient(c.email, c.full_name); setMsg(`✅ Invitation envoyée à ${c.email}. Le compte se lie automatiquement à la fiche dès que le client clique sur le lien.`) }
    catch (e: any) { setMsg('Erreur : ' + e.message) }
  }

  const filtered = clients.filter(c => !q || [c.full_name, c.email, c.company, c.city, c.phone].some(x => (x || '').toLowerCase().includes(q.toLowerCase())))

  return (
    <Layout title="Clients" actions={<Btn onClick={() => setForm({})}>+ Nouveau client</Btn>}>
      <input className={inputCls + ' max-w-md mb-4'} placeholder="Rechercher un client…" value={q} onChange={e => setQ(e.target.value)} />
      <Msg msg={msg} />
      {loading ? <p className="text-acier">Chargement…</p> : (
        <div className="border border-white/10 rounded overflow-x-auto mt-4">
          <table className="w-full text-sm min-w-[760px]">
            <thead className="bg-white/5 text-acier text-[11px] uppercase tracking-widest">
              <tr><th className="text-left px-4 py-3">Client</th><th className="text-left px-4 py-3">Courriel</th><th className="text-left px-4 py-3">Téléphone</th><th className="text-left px-4 py-3">Ville</th><th className="text-center px-4 py-3">Projets</th><th className="text-left px-4 py-3">Compte portail</th></tr>
            </thead>
            <tbody>
              {filtered.map(c => (
                <tr key={c.id} className="border-t border-white/5 hover:bg-white/[0.03]">
                  <td className="px-4 py-3"><a href={`/admin/clients/${c.id}`} className="font-medium hover:text-orange">{clientLabel(c)}</a>{c.company && <div className="text-xs text-acier">{c.full_name}</div>}<div className="text-[10px] uppercase tracking-wider text-acier">{c.type}</div></td>
                  <td className="px-4 py-3 text-acier">{c.email}</td>
                  <td className="px-4 py-3 text-acier">{c.phone || '—'}</td>
                  <td className="px-4 py-3 text-acier">{c.city || '—'}</td>
                  <td className="px-4 py-3 text-center">{counts[c.id] || 0}</td>
                  <td className="px-4 py-3">
                    {c.profile_id ? <span className="text-[10px] uppercase tracking-wider px-2 py-1 rounded bg-green-500/15 text-green-300">Actif</span>
                      : <button onClick={() => invite(c)} className="text-[10px] uppercase tracking-wider px-2 py-1 rounded bg-yellow-500/15 text-yellow-300 hover:bg-yellow-500/25">Inviter par courriel</button>}
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && <tr><td colSpan={6} className="px-4 py-8 text-center text-acier">Aucun client.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
      {form && <ClientForm initial={form} onClose={() => { setForm(null); setParams({}) }} onSaved={c => { setForm(null); setParams({}); load(); setMsg(`✅ ${clientLabel(c)} enregistré.`) }} />}
    </Layout>
  )
}
